import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const ClothSec = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  img {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    user-select: none;
  }
`;
export interface Props {
  data: ISimejiItem;
  color?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Cloth({ data }: Props) {
  const { skinColor, innerClothColor, innerCloth } = data;

  return (
    <ClothSec className="cloth">
      {/* 이너 -기본 */}
      <svg
        width="100"
        height="120"
        viewBox="0 0 100 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color={data.lineColor}
      >
        {/* 바디부분 */}
        <path d="M42 84H60L63 101H39L42 84Z" fill={skinColor} />
        {!innerCloth && (
          <path
            d="M39.5 101.5C39.5 101.5 41 90.8333 42 85.5L50.5001 88.5L60.0001 85.5L62.0001 101.5H39.5Z"
            fill={innerClothColor}
            stroke="currentColor"
            strokeLinecap="round"
          />
        )}
      </svg>
      <img src={innerCloth} alt="" />
    </ClothSec>
  );
}

export default Cloth;
